export const Subject = {
  StaffCalendar: "StaffCalendar",
  MemberList: "MemberList",
  MemberProfile: "MemberProfile",
  Reports: "Reports",
  Settings: "Settings",
  Sales: "Sales",
  Dashboard: "Dashboard",
  GlobalSearch: "GlobalSearch",
  CheckoutPrice: "CheckoutPrice",
  Invoices: "Invoices",
  Leads: "Leads",
  Marketing: "Marketing",
  Task: "Task",
  StaffAccount: "StaffAccount",
  Email: "Email",
  SMS: "SMS",
  Appointments: "Appointments",
  AppointmentAvailability: "AppointmentAvailability",
  FacilityAvailability: "FacilityAvailability",
  Access: "Access",
  StripeConnect: "StripeConnect",
  XeroConnect: "XeroConnect",
  ZapierConnect: "ZapierConnect",
  Integrations: "Integrations",
  Payments: "Payments",
  PaymentMethods: "PaymentMethods",
  GiftVouchers: "GiftVouchers"
} as const;

export type SubjectType = keyof typeof Subject;
